<main class="main mt-3">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>
          Video (required):
          <br />
          <span class="disclaimer">Formats: MP4, MOV or GIF. Max file size: 4 GB.</span>
          <br />
          <span class="disclaimer">Allowed dimensions: 1440x1440 (1:1, desktop or mobile) or 1440x1800 (4:5, mobile only).</span>
          <br />
          <span class="disclaimer">H.264, square pixels, fixed frame rate, progressive scan, stereo AAC audio at 128 kbps+.</span>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <app-video-upload (videoSrcEvent)="onChange($event, 'Video')" [videoSrc]="block.variables?.['Video'] ?? ''" [blockId]="block.blockId"></app-video-upload>
        </div>
      </div>
    </div>
  </div>
</main>
